export default __webpack_public_path__ + "static/media/background-signup.72cd623a.mp4";